module.exports = __webpack_public_path__ + "img/programme3.ebae6950.png";